//TODO: rewrite to use proper types
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import {
  NivoStackedBarChartData,
  PieChartData,
  SASDashboardBackendChartDataType,
  StackedBarChartData,
  StackedBarChartDataRow,
} from './types';

// Typeguads. TODO: move to a separate file

function isStackedBarChartDataRow(obj: any): obj is StackedBarChartDataRow {
  return (
    (typeof obj.category === 'string' ||
      typeof obj.category === 'number' ||
      obj.category instanceof Date) &&
    typeof obj.sub_category === 'string' &&
    typeof obj.value === 'number'
  );
}

function isStackedBarChartData(data: any): data is StackedBarChartData {
  return Array.isArray(data) && data.every(isStackedBarChartDataRow);
}

// Converters

const convertToNivoStackedBarChartData = (
  data: StackedBarChartData,
): NivoStackedBarChartData[] => {
  // Find all distinct sub_category values
  const subCategories = Array.from(
    new Set(data.map((row) => row.sub_category)),
  );

  // Group data by category
  const groupedData = data.reduce((acc, row) => {
    const categoryKey = row.category.toString();
    if (!acc[categoryKey]) {
      acc[categoryKey] = { id: categoryKey };
      subCategories.forEach((subCategory) => {
        acc[categoryKey][subCategory] = 0;
      });
    }
    acc[categoryKey][row.sub_category] = row.value;
    return acc;
  }, {} as { [key: string]: NivoStackedBarChartData });

  // Convert grouped data to array
  return Object.values(groupedData);
};

type NivoMappedData<T> = {
  [K in keyof T]: T[K] extends StackedBarChartData
    ? NivoStackedBarChartData[]
    : T[K];
};

export interface BackendData<T> {
  [key: string]: SASDashboardBackendChartDataType<T>;
}

export function convertBackendDataToNivo<T extends object>(
  data: BackendData<T> | undefined,
): NivoMappedData<T> {
  if (!data || typeof data !== 'object') {
    return {} as NivoMappedData<T>;
  }
  const convertedData: Partial<NivoMappedData<T>> = {};

  Object.keys(data).forEach((key) => {
    const chartData = data[key];

    if (isStackedBarChartData(chartData)) {
      convertedData[key] = convertToNivoStackedBarChartData(chartData);
    } else {
      convertedData[key] = data[key];
    }
  });

  return convertedData as NivoMappedData<T>;
}

export function shortenNumber(num: number, maxSymbols: number): string {
  if (typeof num !== 'number') {
    return '';
  }

  const suffixes = ['', 'k', 'm', 'b', 't'];
  let suffixIndex = 0;

  if (num === 0) {
    return '0';
  }

  while (Math.abs(num) >= 1000 && suffixIndex < suffixes.length - 1) {
    num /= 1000;
    suffixIndex++;
  }

  const numStr = num.toFixed(1);
  const formattedNum = numStr.endsWith('.0') ? num.toFixed(0) : numStr;
  const result =
    formattedNum.length + suffixes[suffixIndex].length <= maxSymbols
      ? `${formattedNum}${suffixes[suffixIndex]}`
      : num.toFixed(0) + suffixes[suffixIndex];

  if (Math.abs(num) < 1) {
    return num.toFixed(maxSymbols);
  }

  return result;
}

export function getCategoryValue(
  pieChartData: any[],
  category: string,
): number {
  return pieChartData?.find((item) => item.category === category)?.value ?? 0;
}

export function getPieTotalValue(pieChartData: any[]): number {
  return pieChartData?.reduce((acc, curr) => acc + curr.value, 0) ?? 0;
}

export function calculatePercentage(
  categoryValue: number,
  remainerValue: number,
): number {
  const totalSum = categoryValue + remainerValue;
  return totalSum !== 0 ? (categoryValue / totalSum) * 100 : 0;
}

export function calculateCategoryPercentage(
  data: PieChartData,
  c1: string,
  c2: string,
): number {
  return calculatePercentage(
    getCategoryValue(data, c1),
    getCategoryValue(data, c2),
  );
}